"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as queries from "./gql";
import { getDecidimData } from "../utils";
import configStore from "../stores/configStore";
const makeQuery = (queryName, responseKey = void 0) => (..._0) => __async(void 0, [..._0], function* (params = {}) {
  const _responseKey = responseKey ? responseKey : queryName;
  const { locale, defaultLocale } = configStore.getState();
  const variables = __spreadProps(__spreadValues({}, params.variables || {}), { locale, defaultLocale });
  const queryParams = __spreadProps(__spreadValues({}, params), { variables });
  const response = yield getDecidimData(queries[queryName], queryParams);
  if (!(response == null ? void 0 : response.data)) return { nodes: [] };
  return response.data[_responseKey];
});
export default makeQuery;
